import AdminNavRoutesPermissions from "newadmin/util/AdminNavRoutesPermissions";
import CampaignNavRoutesPermissions from "campaign/util/CampaignNavRoutesPermissions";

const NavRoutesPermissions = {
  ...AdminNavRoutesPermissions,
  ...CampaignNavRoutesPermissions,
};

export default NavRoutesPermissions;
